export default __webpack_public_path__ + "static/media/near.fa45d9d5.svg";